export const AURORA_PALETTE_STORAGE_KEY = 'ownyou_palette';
export const AURORA_PALETTE_CHANGE_EVENT = 'ownyou:palette-change';
export const DEFAULT_AURORA_PALETTE = 'botanical';
export const auroraPalettes = {
    terracotta: {
        id: 'terracotta',
        label: 'Terracotta',
        bg: 'radial-gradient(circle at 18% 12%, #FFE1CB 0, transparent 32%), #F8EFE7',
        bgMorning: 'radial-gradient(circle at 18% 12%, #FFE6D3 0, transparent 34%), #FAF0E8',
        bgMidday: 'radial-gradient(circle at 78% 20%, #F4B183 0, transparent 30%), #F8EFE7',
        bgDusk: 'radial-gradient(circle at 70% 18%, #C96C57 0, transparent 32%), #F0DED2',
        ink: '#2F241F',
        inkDim: '#68564B',
        inkSoft: '#9A8172',
        inkLine: 'rgba(88, 65, 54, 0.18)',
        accent: '#B85C3E',
        accent2: '#D98A58',
        accent3: '#6B8F71',
        accent4: '#E6B17E',
        amber: '#DFA85F',
        iris: '#8067A8',
        blush: '#E6A0A0',
        mint: '#B8C9A8',
        coral: '#D36B52',
        teal: '#578C84',
        clay: '#A56D55',
        ochre: '#C5903F',
        green: '#5F7C62',
        swatch: ['#B85C3E', '#D98A58', '#6B8F71', '#E6B17E', '#2F241F'],
    },
    arctic: {
        id: 'arctic',
        label: 'Arctic',
        bg: 'radial-gradient(circle at 22% 14%, #DDF4FF 0, transparent 34%), #F2F8FA',
        bgMorning: 'radial-gradient(circle at 22% 14%, #E5F8FF 0, transparent 34%), #F4FAFB',
        bgMidday: 'radial-gradient(circle at 76% 22%, #B8DAE8 0, transparent 30%), #F2F8FA',
        bgDusk: 'radial-gradient(circle at 76% 22%, #94BFD0 0, transparent 30%), #E9F1F4',
        ink: '#162C35',
        inkDim: '#4B6873',
        inkSoft: '#7E98A2',
        inkLine: 'rgba(51, 86, 99, 0.18)',
        accent: '#327D97',
        accent2: '#7BBBD0',
        accent3: '#A7C7B9',
        accent4: '#D8B77D',
        amber: '#D7A953',
        iris: '#6D7FB5',
        blush: '#D8A9B1',
        mint: '#A7D0BF',
        coral: '#D78070',
        teal: '#327D97',
        clay: '#8EA3A8',
        ochre: '#C09645',
        green: '#5F877B',
        swatch: ['#327D97', '#7BBBD0', '#A7C7B9', '#D8B77D', '#162C35'],
    },
    botanical: {
        id: 'botanical',
        label: 'Botanical',
        bg: 'radial-gradient(circle at 20% 12%, #DBE8CC 0, transparent 34%), #F4F0E6',
        bgMorning: 'radial-gradient(circle at 20% 12%, #E8F1D8 0, transparent 34%), #F7F2E8',
        bgMidday: 'radial-gradient(circle at 78% 20%, #C7D9B4 0, transparent 32%), #F4F0E6',
        bgDusk: 'radial-gradient(circle at 75% 22%, #8FA17A 0, transparent 32%), #E9E2D4',
        ink: '#1E2A1D',
        inkDim: '#56624E',
        inkSoft: '#8A947F',
        inkLine: 'rgba(54, 72, 48, 0.18)',
        accent: '#52744D',
        accent2: '#9BAF74',
        accent3: '#C9955D',
        accent4: '#738E8A',
        amber: '#C9A052',
        iris: '#7672A8',
        blush: '#D6A0A0',
        mint: '#B9D0A7',
        coral: '#C87863',
        teal: '#5F8D83',
        clay: '#A8795E',
        ochre: '#B98D3E',
        green: '#52744D',
        swatch: ['#52744D', '#9BAF74', '#C9955D', '#738E8A', '#1E2A1D'],
    },
    dusk: {
        id: 'dusk',
        label: 'Dusk',
        bg: 'radial-gradient(circle at 18% 16%, #DAD2FF 0, transparent 34%), #F0ECF7',
        bgMorning: 'radial-gradient(circle at 18% 16%, #E8E0FF 0, transparent 34%), #F3EFF8',
        bgMidday: 'radial-gradient(circle at 78% 22%, #BCA8DA 0, transparent 32%), #F0ECF7',
        bgDusk: 'radial-gradient(circle at 76% 22%, #74628E 0, transparent 32%), #E6DEEF',
        ink: '#282237',
        inkDim: '#5C5270',
        inkSoft: '#8D82A2',
        inkLine: 'rgba(76, 64, 100, 0.18)',
        accent: '#6E5AA8',
        accent2: '#B58AC7',
        accent3: '#C88E6F',
        accent4: '#7C9A97',
        amber: '#C7A052',
        iris: '#6E5AA8',
        blush: '#D3A0BE',
        mint: '#ACC8B8',
        coral: '#C77A6E',
        teal: '#648B8B',
        clay: '#9B716B',
        ochre: '#B78B42',
        green: '#6F8062',
        swatch: ['#6E5AA8', '#B58AC7', '#C88E6F', '#7C9A97', '#282237'],
    },
    monochrome: {
        id: 'monochrome',
        label: 'Editorial',
        bg: 'radial-gradient(circle at 18% 14%, #EFEFE9 0, transparent 34%), #F8F6F0',
        bgMorning: 'radial-gradient(circle at 18% 14%, #F6F5EF 0, transparent 34%), #FBF8F3',
        bgMidday: 'radial-gradient(circle at 78% 20%, #D9D6CE 0, transparent 32%), #F8F6F0',
        bgDusk: 'radial-gradient(circle at 78% 20%, #A9A39A 0, transparent 32%), #EBE8E0',
        ink: '#20201D',
        inkDim: '#5B5A55',
        inkSoft: '#8B8982',
        inkLine: 'rgba(48, 47, 43, 0.18)',
        accent: '#3F3E38',
        accent2: '#8D8A80',
        accent3: '#B6A16E',
        accent4: '#70817C',
        amber: '#B99A45',
        iris: '#6F6B80',
        blush: '#C2A2A2',
        mint: '#AAB9A7',
        coral: '#B57C6F',
        teal: '#6F8782',
        clay: '#8A7465',
        ochre: '#A98437',
        green: '#667560',
        swatch: ['#3F3E38', '#8D8A80', '#B6A16E', '#70817C', '#20201D'],
    },
};
export const auroraUniversalTokens = {
    card: 'rgba(255, 253, 248, 0.72)',
    cardSolid: '#FDFAF3',
    cardBorder: 'rgba(255, 255, 255, 0.9)',
    font: "'Instrument Serif', 'Cormorant Garamond', Georgia, serif",
    fontUi: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
    fontMono: "'JetBrains Mono', 'SF Mono', ui-monospace, monospace",
    radius: '28px',
    cardShadow: '0 1px 2px rgba(20, 10, 50, 0.06), 0 12px 40px -12px rgba(90, 60, 200, 0.18)',
};
export const auroraResponsiveTokens = {
    contentMaxWidthMobile: '402px',
    contentMaxWidthDesktop: '1280px',
    sidebarWidthCollapsed: '64px',
    sidebarWidthExpanded: '232px',
    drawerWidth: '420px',
    modalMaxWidthSm: '460px',
    modalMaxWidthMd: '540px',
    modalMaxWidthLg: '640px',
    modalMaxWidthCorner: '480px',
    typeDisplayMobile: 'clamp(30px, 8vw, 36px)',
    typeDisplayDesktop: 'clamp(40px, 6vw, 84px)',
    typeTitleMobile: 'clamp(22px, 6vw, 28px)',
    typeTitleDesktop: 'clamp(32px, 4vw, 48px)',
};
export function isAuroraPaletteId(value) {
    return Boolean(value && value in auroraPalettes);
}
export function getPalette(id) {
    return auroraPalettes[isAuroraPaletteId(id) ? id : DEFAULT_AURORA_PALETTE];
}
export function readStoredPalette(storage = getStorage()) {
    const stored = storage?.getItem(AURORA_PALETTE_STORAGE_KEY);
    return isAuroraPaletteId(stored) ? stored : DEFAULT_AURORA_PALETTE;
}
export function setPalette(id, storage = getStorage()) {
    const palette = getPalette(id);
    storage?.setItem(AURORA_PALETTE_STORAGE_KEY, palette.id);
    dispatchPaletteChange(palette.id);
    return palette;
}
export function getAuroraCssVariables(id) {
    const palette = getPalette(id);
    return {
        '--aurora-palette': palette.id,
        '--aurora-bg': palette.bg,
        '--aurora-bg-morning': palette.bgMorning,
        '--aurora-bg-midday': palette.bgMidday,
        '--aurora-bg-dusk': palette.bgDusk,
        '--aurora-ink': palette.ink,
        '--aurora-ink-dim': palette.inkDim,
        '--aurora-ink-soft': palette.inkSoft,
        '--aurora-ink-line': palette.inkLine,
        '--aurora-accent': palette.accent,
        '--aurora-accent-2': palette.accent2,
        '--aurora-accent-3': palette.accent3,
        '--aurora-accent-4': palette.accent4,
        '--aurora-amber': palette.amber,
        '--aurora-iris': palette.iris,
        '--aurora-blush': palette.blush,
        '--aurora-mint': palette.mint,
        '--aurora-coral': palette.coral,
        '--aurora-teal': palette.teal,
        '--aurora-clay': palette.clay,
        '--aurora-ochre': palette.ochre,
        '--aurora-green': palette.green,
        '--aurora-card': auroraUniversalTokens.card,
        '--aurora-card-solid': auroraUniversalTokens.cardSolid,
        '--aurora-card-border': auroraUniversalTokens.cardBorder,
        '--aurora-font': auroraUniversalTokens.font,
        '--aurora-font-ui': auroraUniversalTokens.fontUi,
        '--aurora-font-mono': auroraUniversalTokens.fontMono,
        '--aurora-radius': auroraUniversalTokens.radius,
        '--aurora-card-shadow': auroraUniversalTokens.cardShadow,
        '--aurora-content-max-width-mobile': auroraResponsiveTokens.contentMaxWidthMobile,
        '--aurora-content-max-width-desktop': auroraResponsiveTokens.contentMaxWidthDesktop,
        '--aurora-sidebar-width-collapsed': auroraResponsiveTokens.sidebarWidthCollapsed,
        '--aurora-sidebar-width-expanded': auroraResponsiveTokens.sidebarWidthExpanded,
        '--aurora-drawer-width': auroraResponsiveTokens.drawerWidth,
        '--aurora-modal-max-width-sm': auroraResponsiveTokens.modalMaxWidthSm,
        '--aurora-modal-max-width-md': auroraResponsiveTokens.modalMaxWidthMd,
        '--aurora-modal-max-width-lg': auroraResponsiveTokens.modalMaxWidthLg,
        '--aurora-modal-max-width-corner': auroraResponsiveTokens.modalMaxWidthCorner,
        '--aurora-type-display-mobile': auroraResponsiveTokens.typeDisplayMobile,
        '--aurora-type-display-desktop': auroraResponsiveTokens.typeDisplayDesktop,
        '--aurora-type-title-mobile': auroraResponsiveTokens.typeTitleMobile,
        '--aurora-type-title-desktop': auroraResponsiveTokens.typeTitleDesktop,
    };
}
function getStorage() {
    if (typeof window === 'undefined')
        return undefined;
    try {
        const storage = window.localStorage;
        return isStorageLike(storage) ? storage : undefined;
    }
    catch {
        return undefined;
    }
}
function dispatchPaletteChange(paletteId) {
    if (typeof window === 'undefined')
        return;
    window.dispatchEvent(new CustomEvent(AURORA_PALETTE_CHANGE_EVENT, {
        detail: { paletteId },
    }));
}
function isStorageLike(value) {
    return Boolean(value &&
        typeof value === 'object' &&
        typeof value.getItem === 'function' &&
        typeof value.setItem === 'function');
}
//# sourceMappingURL=index.js.map